var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClearicon = function SvgClearicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.48 12.352a.4.4 0 0 1 0 .568l-.56.56a.4.4 0 0 1-.568 0L8 9.128 3.648 13.48a.4.4 0 0 1-.568 0l-.56-.56a.4.4 0 0 1 0-.568L6.872 8 2.52 3.648a.4.4 0 0 1 0-.568l.56-.56a.4.4 0 0 1 .568 0L8 6.872l4.352-4.352a.4.4 0 0 1 .568 0l.56.56a.4.4 0 0 1 0 .568L9.128 8l4.352 4.352Z"
  })));
};
export default SvgClearicon;